<script setup lang="ts">
import type { RouterOutput } from "~/plugins/trpc.client";
interface Props {
  advertiserName: string;
  pageData: RouterOutput["getLandingPageData"];
}

const props = defineProps<Props>();
</script>
<template>
  <div
    class="relative"
    :style="{ backgroundColor: pageData?.color_mission_bg || '#e2e2e2e' }"
  >
    <svg
      class="absolute z-[1] overflow-hidden inset-0 w-full h-full object-cover object-center"
      width="1511"
      height="1112"
      viewBox="0 0 1511 1112"
      preserveAspectRatio="xMidYMid slice"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.25998 -201.669C-128.083 31.0206 -48.3581 328.559 184.331 462.903C190.795 466.635 197.309 470.201 203.868 473.604C117.247 514.405 41.7615 581.128 -9.74012 670.331C-144.083 903.021 -64.3581 1200.56 168.331 1334.9C401.021 1469.25 698.559 1389.52 832.903 1156.83C880.768 1073.93 901.458 982.789 897.738 893.734C1087.36 1025.25 1349.65 1006.53 1518.59 837.589C1708.58 647.599 1708.58 339.564 1518.59 149.574C1353.95 -15.0645 1100.67 -37.0333 912.374 83.6672C928.079 -98.6429 839.77 -282.203 670.831 -379.74C438.142 -514.083 140.603 -434.358 6.25998 -201.669ZM328.211 412.681C492.06 456.667 671.347 387.524 760.203 233.621C866.264 49.9185 803.323 -184.98 619.621 -291.041C435.919 -397.101 201.02 -334.16 94.9592 -150.458C4.89161 5.54333 36.7007 198.466 160.843 318.053C181.932 338.368 215.53 331.051 230.171 305.692L232.852 301.048C245.206 279.651 239.48 252.717 222.531 234.739C139.404 146.57 119.974 11.0557 183.674 -99.2756C261.452 -233.99 433.711 -280.147 568.426 -202.369C703.141 -124.592 749.297 47.6674 671.52 182.382C646.597 225.55 611.973 259.624 571.991 283.442C536.054 304.85 505.58 264.707 526.496 228.48L579.341 136.949C580.532 135.053 581.692 133.127 582.82 131.172C632.315 45.4442 602.943 -64.1754 517.215 -113.67C431.488 -163.165 321.868 -133.793 272.373 -48.0651C240.452 7.22363 241.335 72.4499 268.984 125.076C283.696 153.08 321.396 147.687 337.213 120.291L400.248 11.1098C413.838 -12.4283 444.575 -20.1241 468.902 -6.07913C493.229 7.96585 501.933 38.433 488.343 61.9711L481.957 72.9878L327.177 341.097L311.259 368.689C301.431 385.712 309.226 407.585 328.211 412.681ZM510.952 542.481C347.102 498.496 167.815 567.638 78.9591 721.542C-27.1013 905.244 35.8396 1140.14 219.542 1246.2C403.244 1352.26 638.143 1289.32 744.203 1105.62C834.271 949.619 802.462 756.697 678.319 637.109C657.23 616.794 623.632 624.112 608.991 649.471L606.31 654.114C593.956 675.512 599.683 702.446 616.632 720.423C699.758 808.592 719.188 944.107 655.489 1054.44C577.711 1189.15 405.452 1235.31 270.737 1157.53C136.022 1079.75 89.8652 907.495 167.643 772.78C192.566 729.613 227.19 695.538 267.171 671.721C303.108 650.313 333.582 690.456 312.667 726.682L259.821 818.214C258.631 820.11 257.471 822.036 256.342 823.991C206.847 909.718 236.22 1019.34 321.947 1068.83C407.675 1118.33 517.294 1088.96 566.789 1003.23C598.71 947.939 597.827 882.713 570.179 830.086C555.466 802.082 517.767 807.476 501.95 834.872L438.914 944.053C425.324 967.591 394.587 975.287 370.26 961.242C345.934 947.197 337.23 916.729 350.82 893.191L357.205 882.175L511.986 614.065L527.903 586.473C537.732 569.45 529.936 547.578 510.952 542.481ZM902.996 221.997C1028.66 96.3349 1219.73 75.9511 1366.61 160.845C1383.63 170.682 1385.5 193.826 1371.6 207.726L1349.09 230.258L1130.19 449.171L1121.17 458.16C1101.95 477.379 1102.47 509.06 1122.33 528.923C1142.2 548.786 1173.88 549.308 1193.1 530.089L1282.24 440.943C1304.61 418.574 1342.42 423.122 1349.39 453.98C1362.47 511.968 1346.44 575.201 1301.3 620.344C1231.3 690.34 1117.82 690.34 1047.82 620.344C977.823 550.347 977.823 436.861 1047.82 366.865C1049.42 365.268 1051.03 363.708 1052.68 362.185L1127.41 287.45C1156.99 257.871 1137.94 211.208 1097.69 222.586C1052.91 235.244 1010.64 259.196 975.397 294.442C865.403 404.436 865.403 582.772 975.397 692.766C1085.39 802.761 1263.73 802.761 1373.72 692.766C1463.81 602.681 1480.11 466.755 1422.64 360.076C1410.92 338.324 1412.36 310.826 1429.83 293.355L1433.62 289.564C1454.33 268.858 1488.67 270.486 1503.79 295.567C1592.75 443.21 1573.54 637.791 1446.17 765.166C1296.17 915.158 1052.99 915.158 902.996 765.166C753.004 615.174 753.004 371.989 902.996 221.997Z"
        fill="black"
        fill-opacity="0.2"
      />
    </svg>

    <div
      class="relative pt-8 md:pt-[80px] z-[2] px-4 2xl:px-0 max-w-[1200px] mx-auto text-white"
    >
      <div class="grid lg:grid-cols-3">
        <div class="text-4xl lg:leading-[64px] lg:text-[56px]">Mission:</div>
        <div class="col-span-2 mt-4 sm:mt-0">
          <p class="text-2xl lg:leading-[64px] lg:text-[56px] max-w-[656px]">
            Help others discover the value of {{ props.advertiserName }} through
            your voice
          </p>
        </div>
      </div>

      <div
        class="grid-cols-3 gap-4 space-y-16 lg:space-y-0 mt-14 md:mt-[72px] lg:grid"
      >
        <div>
          <svg
            width="50"
            height="50"
            viewBox="0 0 50 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M24.9792 4.16663C13.4792 4.16663 4.16675 13.5 4.16675 25C4.16675 36.5 13.4792 45.8333 24.9792 45.8333C36.5001 45.8333 45.8334 36.5 45.8334 25C45.8334 13.5 36.5001 4.16663 24.9792 4.16663ZM33.8126 37.5L25.0001 32.1875L16.1876 37.5L18.5209 27.4791L10.7501 20.75L21.0001 19.875L25.0001 10.4166L29.0001 19.8541L39.2501 20.7291L31.4792 27.4583L33.8126 37.5Z"
              fill="white"
            />
          </svg>

          <p class="text-lg lg:text-2xl mt-8">Rewards Every Week</p>
          <p class="text-lg mt-2 lg:mt-9">
            Compete for generous campaign budgets every week, and use data to
            improve your posts quality.
          </p>
        </div>
        <div>
          <svg
            width="50"
            height="50"
            viewBox="0 0 50 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M41.6667 25C41.6667 24.2916 41.5834 23.6041 41.5001 22.9166H41.5378C40.7792 16.8331 36.7419 11.7678 31.2501 9.54479V10.4166C31.2501 10.5962 31.2514 10.7731 31.2526 10.9468C31.2674 12.9906 31.2789 14.5833 29.1667 14.5833H25.0001V18.75C25.0001 19.8958 24.0626 20.8333 22.9167 20.8333H16.6667V25H29.1667C30.3126 25 31.2501 25.9375 31.2501 27.0833V33.3333H33.3334C35.2084 33.3333 36.7501 34.5416 37.2917 36.2291C40.0001 33.2708 41.6667 29.3333 41.6667 25ZM10.3964 33.0382C12.9143 37.5994 17.5109 40.8502 22.9167 41.5208V37.5C20.6251 37.5 18.7501 35.625 18.7501 33.3333V31.25L8.77091 21.2708C8.50008 22.4791 8.33341 23.7083 8.33341 25C8.33341 27.9147 9.08161 30.6546 10.3964 33.0382ZM28.0881 4.3939C38.1296 5.88591 45.8334 14.5433 45.8334 25C45.8334 36.5059 36.506 45.8333 25.0001 45.8333C13.5001 45.8333 4.16675 36.5 4.16675 25C4.16675 13.494 13.4941 4.16663 25.0001 4.16663C26.0536 4.16663 27.0829 4.24394 28.0881 4.3939Z"
              fill="white"
            />
          </svg>

          <p class="text-lg lg:text-2xl mt-8">Content Creator Toolkit</p>
          <p class="text-lg mt-2 lg:mt-9">
            Become a Top creator with the help of Evangelist AI driven
            suggestions and impact metrics.
          </p>
        </div>

        <div>
          <div>
            <svg
              width="50"
              height="50"
              viewBox="0 0 50 50"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.5417 8.33337C14.9231 8.33337 16.2478 8.88211 17.2246 9.85886C18.2013 10.8356 18.7501 12.1604 18.7501 13.5417C18.7501 14.923 18.2013 16.2478 17.2246 17.2246C16.2478 18.2013 14.9231 18.75 13.5417 18.75C12.1604 18.75 10.8357 18.2013 9.8589 17.2246C8.88215 16.2478 8.33341 14.923 8.33341 13.5417C8.33341 12.1604 8.88215 10.8356 9.8589 9.85886C10.8357 8.88211 12.1604 8.33337 13.5417 8.33337ZM37.5001 8.33337C38.8814 8.33337 40.2062 8.88211 41.1829 9.85886C42.1597 10.8356 42.7084 12.1604 42.7084 13.5417C42.7084 14.923 42.1597 16.2478 41.1829 17.2246C40.2062 18.2013 38.8814 18.75 37.5001 18.75C36.1187 18.75 34.794 18.2013 33.8172 17.2246C32.8405 16.2478 32.2917 14.923 32.2917 13.5417C32.2917 12.1604 32.8405 10.8356 33.8172 9.85886C34.794 8.88211 36.1187 8.33337 37.5001 8.33337ZM4.16675 27.78C4.16675 23.9454 7.27873 20.8334 11.1134 20.8334H13.8933C14.9285 20.8334 15.9115 21.0612 16.797 21.4649C16.7123 21.9336 16.6733 22.4219 16.6733 22.9167C16.6733 25.4037 17.767 27.6368 19.4923 29.1667C19.4792 29.1667 19.4662 29.1667 19.4467 29.1667H5.55347C4.79175 29.1667 4.16675 28.5417 4.16675 27.78ZM30.5535 29.1667C30.5404 29.1667 30.5274 29.1667 30.5079 29.1667C32.2397 27.6368 33.3269 25.4037 33.3269 22.9167C33.3269 22.4219 33.2813 21.9401 33.2032 21.4649C34.0886 21.0547 35.0717 20.8334 36.1069 20.8334H38.8868C42.7214 20.8334 45.8334 23.9454 45.8334 27.78C45.8334 28.5482 45.2084 29.1667 44.4467 29.1667H30.5535ZM18.7501 22.9167C18.7501 21.2591 19.4086 19.6694 20.5807 18.4973C21.7528 17.3252 23.3425 16.6667 25.0001 16.6667C26.6577 16.6667 28.2474 17.3252 29.4195 18.4973C30.5916 19.6694 31.2501 21.2591 31.2501 22.9167C31.2501 24.5743 30.5916 26.164 29.4195 27.3361C28.2474 28.5082 26.6577 29.1667 25.0001 29.1667C23.3425 29.1667 21.7528 28.5082 20.5807 27.3361C19.4086 26.164 18.7501 24.5743 18.7501 22.9167ZM12.5001 39.9284C12.5001 35.1368 16.3868 31.25 21.1785 31.25H28.8217C33.6134 31.25 37.5001 35.1368 37.5001 39.9284C37.5001 40.8855 36.7253 41.6667 35.7618 41.6667H14.2384C13.2813 41.6667 12.5001 40.892 12.5001 39.9284Z"
                fill="white"
              />
            </svg>

            <p class="text-lg lg:text-2xl mt-8">Community Leaderboard</p>
            <p class="text-lg mt-2 lg:mt-9">
              Grow your influencer profile up and compare your impact with
              others creators across different communities.
            </p>
          </div>
        </div>
      </div>

      <div class="border-t border-white mt-14 md:mt-[80px]"></div>

      <div class="mt-14 lg:flex items-center justify-between">
        <div class="text-xl lg:text-2xl">Are you an advertiser?</div>

        <a
          :href="`https://evangelist.gg?utm_source=${props.advertiserName.toLocaleLowerCase()}-landing&utm_campaign=visit-evangelist-site`"
          target="_blank"
          data-analytics-click-id="button_visit_evangelist_clicked"
          class="text-sm mt-6 flex justify-center lg:mt-0 w-full lg:w-auto bg-white text-black px-[22px] py-[12px] rounded-full"
        >
          Visit Evangelist.gg
        </a>
      </div>

      <div class="lg:mt-[120px] mt-10 lg:grid grid-cols-3">
        <div class="flex items-center gap-2">
          <svg
            width="24"
            class="shrink-0"
            height="24"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M5.64466 11.2888C2.52734 11.2888 0.000256155 8.76172 0.000256292 5.6444C0.000256428 2.52708 2.52734 -3.82987e-07 5.64466 -2.46725e-07C8.76198 -1.10462e-07 11.2891 2.52709 11.2891 5.6444C11.2891 8.76172 8.76198 11.2888 5.64466 11.2888ZM10.1008 5.6444C10.1008 7.70623 8.70045 9.441 6.79898 9.94955C6.57866 10.0085 6.37345 9.83393 6.37345 9.60587L6.37345 9.23642C6.37345 9.23635 6.3734 9.2363 6.37333 9.2363C6.37326 9.2363 6.3732 9.23624 6.3732 9.23617L6.3732 5.64453C6.3732 5.64446 6.37326 5.6444 6.37333 5.6444C6.3734 5.6444 6.37345 5.64435 6.37345 5.64428L6.37345 5.49679C6.37345 5.18146 6.10926 4.92582 5.78336 4.92582C5.45746 4.92582 5.19326 5.18146 5.19326 5.49679L5.19326 6.95948C5.19326 7.3265 4.84576 7.59939 4.53548 7.40336C3.95239 7.03498 3.56514 6.38473 3.56514 5.64403C3.56514 4.49555 4.49617 3.56452 5.64465 3.56452C6.79314 3.56452 7.72417 4.49555 7.72417 5.64403C7.72417 5.67023 7.72369 5.6963 7.72273 5.72226L7.72273 6.9485C7.72273 7.43382 8.26179 7.66039 8.49869 7.23681C8.76224 6.76557 8.91247 6.22234 8.91247 5.64403C8.91247 3.83927 7.44942 2.37622 5.64465 2.37622C3.83989 2.37622 2.37684 3.83927 2.37684 5.64403C2.37684 7.12213 3.35819 8.37102 4.70489 8.7747C4.97948 8.85701 5.19326 9.09442 5.19326 9.38107L5.19326 9.44328C5.19326 9.78301 4.89813 10.0514 4.56838 9.96966C2.62731 9.48824 1.18855 7.73434 1.18855 5.6444C1.18855 3.18336 3.18362 1.1883 5.64466 1.1883C8.1057 1.1883 10.1008 3.18336 10.1008 5.6444Z"
              fill="white"
            />
          </svg>

          {{ new Date().getFullYear() }} Evangelist
        </div>

        <div class="col-span-2 mt-6 lg:mt-0 text-white/50 sm:flex gap-10">
          <a
            href="https://evangelist.gg/articles/privacy-policy?utm_source=deriverse-landing&utm_campaign=privacy-policy"
            target="_blank"
            class="hover:text-white block transition-colors"
            data-analytics-click-id="button_privacy_policy_clicked"
            data-analytics-event-name="user_site_redirected"
          >
            Privacy policy
          </a>
          <a
            href="https://evangelist.gg/articles/terms?utm_source=deriverse-landing&utm_campaign=terms-and-conditions"
            target="_blank"
            class="hover:text-white mt-2 lg:mt-0 block transition-colors"
          >
            Terms and Conditions
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
